export const visit = (vm, at) => {
at({ "pt-br": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Est\xE1 com problemas para assistir a esse v\xEDdeo?", "playButton": "Reproduzir" } } });
};